import { Component, OnInit } from '@angular/core';
import { settings } from '../../../shared/constants/settings';
import { ListComponent } from '../list.component';

@Component({
  selector: 'app-list-mobile',
  templateUrl: './list-mobile.component.html',
  styleUrls: ['./list-mobile.component.scss']
})
export class ListMobileComponent extends ListComponent implements OnInit {

  page: number = 0;
  moreData: boolean = true;

  ngOnInit(): void {
    super.init();
    this.loadJobs();
  }

  loadJobs() {
    this.page = 0;
    this.moreData = true;
    this.jobs = [];

    this.appendJobs();
  }

  appendJobs() {
    if (!this.moreData) return;

    this.jobService.getList(this.filter, 'projectName', 'asc', this.page)
      .subscribe({
        next: (data) => {
          this.moreData = (data.length == settings.pageSize);
          data.forEach(d => this.jobs.push(d));
        },
        error: (error: string) => this.onError(error)
      });
  }

  onScroll() {
    this.page++;

    this.appendJobs();
  }
}
